import { render, staticRenderFns } from "./TgCustomerServiceDialog.vue?vue&type=template&id=7087e0fe"
import script from "./TgCustomerServiceDialog.vue?vue&type=script&lang=js"
export * from "./TgCustomerServiceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports